/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".line[_ngcontent-%COMP%]{position:relative;text-align:center}.line-label[_ngcontent-%COMP%]{display:inline-block;position:relative;padding:0 16px;background:#fff;font-size:.9em;color:#8492a6}.line[_ngcontent-%COMP%]:before{content:\" \";display:block;position:absolute;top:50%;left:0;width:100%;height:1px;background:#dddddf}"];
export { styles as styles };
